import QueryString from "query-string";

export const getReturnUrlFromQueryString = (): string | null | undefined => {
  let returnUrl = QueryString.parse(window.location.search)["returnUrl"];
  if (returnUrl && Array.isArray(returnUrl)) {
    returnUrl = returnUrl[0];
  }
  return returnUrl;
};
